"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const formatArrayToValue = value => {
  if (!value) return;
  return value.join("-");
};
var _default = exports.default = formatArrayToValue;